module.exports = __webpack_public_path__ + "static/theme-editor-edit-carousel-videos-afdb6cdf8075546d284b71ac7e249b51.png";